import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FooterModule } from './components/footer/footer.module';
import { FourOhFourComponent } from './components/four-oh-four/four-oh-four.component';
import { ZonarUIMaterialModule } from '@livemaps/material';

import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@NgModule({
  declarations: [FourOhFourComponent],
  imports: [
    CommonModule,
    FooterModule,
    ZonarUIMaterialModule,
    FlexLayoutModule,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [FooterModule, FourOhFourComponent],
  providers: [{ provide: MatDialogRef, useValue: MatDialogRef }]
})
export class ZonarUIBrandModule {}
